import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { hojeMenos } from "./formato";

// Filtros na URL: a página de detalhe e o "voltar" mantêm o mesmo recorte.
export function useFiltros() {
  const [params, setParams] = useSearchParams();
  const filtros = useMemo(() => {
    const f = Object.fromEntries(params.entries());
    return { ...f, de: f.de || hojeMenos(29), ate: f.ate || hojeMenos(0) };
  }, [params]);
  const mudar = (novos) => {
    const prox = { ...Object.fromEntries(params.entries()), ...novos };
    Object.keys(prox).forEach((k) => { if (prox[k] === "" || prox[k] == null) delete prox[k]; });
    setParams(prox, { replace: true });
  };
  const query = (extra = {}) => {
    const q = new URLSearchParams({ ...Object.fromEntries(params.entries()), ...extra });
    return q.toString() ? `?${q.toString()}` : "";
  };
  const paraApi = { date_from: filtros.de, date_to: filtros.ate, modulo: filtros.modulo, tipo: filtros.tipo,
    categoria: filtros.categoria, status: filtros.status, busca: filtros.busca };
  return { filtros, mudar, query, paraApi };
}
